import { useForm } from '@/common/form/FormContext';
import { EnumSelect } from '@/common/form/formFields/EnumSelect';
import { useMemo } from 'react';

export const ProgProdPriceBasis = ({ fieldDef }) => {
  const { formValues, assignValue } = useForm();

  const updatedFieldDef = useMemo(() => {
    const isFormula = formValues.progProdCalcType === 'FORMULA';
    if (isFormula) {
      assignValue('pymtBasisId', null);
    }
    return {
      ...fieldDef,
      disabled: fieldDef.disabled || isFormula,
    };
  }, [formValues.progProdCalcType, fieldDef.disabled]);

  return <EnumSelect fieldDef={updatedFieldDef} />;
};
